import React from 'react';
import CookieNotification from 'components/cookie-notification/cookie-notification';
import LocaleContext from 'lib/locale-context';
import { Lexeme } from '@bumble/localization/components';
import Link from 'components/link/link';
import useMediaQuery from 'lib/use-media-query';

const PageCookieNotification: React.FC<React.PropsWithChildren> = () => {
    const lang = React.useContext(LocaleContext);
    const isBreakpointMobileDevice = useMediaQuery(1140);
    const cookieNotificationTitle = isBreakpointMobileDevice
        ? 'Let us know you agree to cookies'
        : null;
    const cookieNotificationText = (
        <>
            We use cookies to make our site work better. This includes analytics cookies and
            advertising cookies. For more information, please check our{' '}
            <Link
                className="cookie-notification__link"
                href={`https://bumble.com/${lang}/cookie-policy`}
                target="_blank"
                rel="noreferrer"
            >
                <Lexeme path="settings@cookies.footer.cookie_policy" />
            </Link>
        </>
    );

    return (
        <CookieNotification
            title={cookieNotificationTitle}
            text={cookieNotificationText}
            hasBlurredBg={true}
            hasCta={true}
        />
    );
};

export default PageCookieNotification;
